import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { styled } from "@mui/material";
import Drawer from "@mui/material/Drawer";
import { SidebarProps } from "./types";

const Sidebar = ({
  maxWidth,
  isSidebarOpen,
  children,
  onCloseSidebar,
  className,
}: SidebarProps) => {
  return (
    <StyledDrawer
      open={isSidebarOpen}
      anchor="left"
      variant="persistent"
      sx={{
        height: "100vh",
        "& .MuiDrawer-paper": {
          maxWidth,
        },
      }}
      className={className}
    >
      <StyledCloseButton
        onClick={() => {
          typeof onCloseSidebar === "function" && onCloseSidebar();
        }}
      />
      {children}
    </StyledDrawer>
  );
};

export default Sidebar;
const StyledDrawer = styled(Drawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {
    width: "100%",
    border: "none",
    overflow: "hidden",
    height: "100vh",
    padding: "1rem 0",
    backgroundColor: theme.tokens.colors.gray[1],
    boxShadow: "12px 0px 12px 0px #0000004D",
  },
}));
const StyledCloseButton = styled(CloseRoundedIcon)(({ theme }) => ({
  fontSize: "1.6rem",
  color: theme.tokens.colors.gray[6],
  cursor: "pointer",
  position: "absolute",
  top: "2rem",
  right: "1.2rem",
  transition: "all 200ms ease",
  "&:hover": {
    color: theme.tokens.colors.gray[7],
  },
}));
